import {
    Component,
    OnInit,
    OnDestroy,
    Renderer2
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    public loginForm: UntypedFormGroup;
    public isAuthLoading = false;
    public ResetPasswordUserName = true;
    public ResetPasswordEmail = false;
    public showPassword: boolean = false;
    public version : string = "";
  message: any;
  currentView: string;
  constructor(private toastr: ToastrService) {
    this.currentView = window["passwordResetView"];
        var _message = window["message"];
        if (_message == null || _message.type == null) {
            return;
      }
      this.message = window["message"];
        console.log(this.message);
    }

    ngOnInit() {
        this.loginForm = new UntypedFormGroup({
            email: new UntypedFormControl(null, Validators.required),
            password: new UntypedFormControl(null, Validators.required)
        });
    }
    public togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }
    async loginByAuth() {
        if (this.loginForm.valid) {
            this.isAuthLoading = true;
            this.isAuthLoading = false;
        } else {
            this.toastr.error('Form is not valid!');
        }
    }

  showEmail() {
    this.currentView = "email";
    }
  showUsername() {
    this.currentView = "username";
    }
}
